import React from 'react';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", lineHeight: '1.6', color: '#333', background: '#f5f5f5', minHeight: '100vh' }}>
      <Helmet>
        <title>Privacy Policy | SugarHathi</title>
        <meta name="description" content="SugarHathi's privacy policy — how Villgrains FarmTech Private Limited collects, uses, and protects your data." />
      </Helmet>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', background: 'white', minHeight: '100vh' }}>

        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '20px', borderBottom: '3px solid #2ecc71' }}>
          <h1 style={{ fontSize: '2.5rem', color: '#2ecc71', margin: '0 0 10px 0', padding: 0 }}>Privacy Policy</h1>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: '0 0 5px 0' }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: 0 }}>Last Updated: June 7, 2026</p>
        </div>

        <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
          Villgrains FarmTech Private Limited (referred to as "we", "us", or "our") operates the website
          <strong style={{ color: '#2c3e50' }}> www.sugarhathi.com</strong> and related services (collectively, the "Platform").
          We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and
          safeguard your information, particularly in connection with payments processed through Razorpay.
          By using our Platform, you consent to the practices described here.
        </p>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>1. Information We Collect</h2>
          <ul style={{ margin: '15px 0 15px 30px' }}>
            <li style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Personal Information:</strong> Name, email address, phone number, and business details provided during registration or orders.</li>
            <li style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Payment Information:</strong> Transaction reference numbers, payment amounts, and bank details. We do not store card numbers, CVV, or net banking credentials. All sensitive payment data is handled by Razorpay.</li>
            <li style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Usage Data:</strong> IP address, browser type, device information, and activity on our Platform.</li>
          </ul>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>2. How We Use Your Information</h2>
          <ul style={{ margin: '15px 0 15px 30px' }}>
            <li style={{ marginBottom: '10px' }}>Processing orders, payments, and deliveries.</li>
            <li style={{ marginBottom: '10px' }}>Providing customer support and responding to inquiries.</li>
            <li style={{ marginBottom: '10px' }}>Sending transactional communications such as order confirmations and invoices.</li>
            <li style={{ marginBottom: '10px' }}>Complying with legal obligations and preventing fraud.</li>
          </ul>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>3. Sharing of Information</h2>
          <ul style={{ margin: '15px 0 15px 30px' }}>
            <li style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Razorpay:</strong> To facilitate secure payment processing. Razorpay handles payment data in compliance with PCI-DSS standards. We do not store or access your full card details.</li>
            <li style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Service Providers:</strong> Hosting, communication, and other third parties who assist in operating our Platform. These parties are contractually obligated to protect your data.</li>
            <li style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Legal Authorities:</strong> When required by law, court order, or government request.</li>
          </ul>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            We do not sell your personal information to third parties.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>4. Data Security</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            We implement reasonable security measures including encryption and access controls to protect your data.
            Razorpay uses industry-standard encryption for all payment transactions.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>5. Your Rights</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Under the Digital Personal Data Protection Act, 2023, you have the right to access, correct, or
            delete your personal data, and to withdraw consent where applicable. To exercise these rights,
            contact us at <strong style={{ color: '#2c3e50' }}>info@villagegrains.com</strong>.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>6. Data Retention</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            We retain your information only as long as necessary for the purposes outlined or as required by law.
            Payment-related records are kept as mandated by RBI and applicable regulations.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>7. Changes to This Policy</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            We may update this Privacy Policy from time to time. Changes will be posted here with the updated
            "Last Updated" date. Continued use of our Platform after changes constitutes acceptance.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>8. Grievance Officer</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Name:</strong> KK Mena</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Designation:</strong> Founder</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>Response Time:</strong> Within 30 days</p>
          </div>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>9. Contact Us</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
            <p style={{ marginBottom: '10px' }}>101B, Vishnu Acharya Nivas, Road No 3, Journalist Colony, Banjara Hills, Hyderabad, Telangana - 500034</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>WhatsApp:</strong> +91 79899 53468</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>Website:</strong> www.sugarhathi.com</p>
          </div>
        </section>

        <div style={{ textAlign: 'center', marginTop: '50px', paddingTop: '30px', borderTop: '2px solid #e0e0e0', color: '#666', fontSize: '0.9rem' }}>
          <p style={{ marginBottom: '5px' }}>&copy; 2026 Villgrains FarmTech Private Limited. All rights reserved.</p>
          <p style={{ margin: 0 }}>Trading as SugarHathi</p>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
